// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"3694976b","2007":"12d31aca","2947":"c3a71a48","3824":"3b53517f","4742":"1e5d9e3e","4858":"12d31aca","7851":"38b31f24","8124":"08322bb5"}[chunkId] + ".chunk.css";
};